export default __webpack_public_path__ + "static/media/portfolio-111.8c704333.jpg";